const ABDefinitionCore = require("../core/ABDefinitionCore");
module.exports = class ABDefinition extends ABDefinitionCore {};
